export default __webpack_public_path__ + "static/media/chat.ef155335.svg";